import { i18n } from 'i18n';
import { FlushVolumeMode } from 'providers/api';
import {
  boolean,
  number,
  object,
  string
} from 'yup';

const positiveNumber = (label: string) => number()
  .typeError(i18n._('Must be a number'))
  .required(i18n._('{label} is required', { label }))
  .moreThan(0, i18n._('{label} must be greater than zero', { label }));

const generateFlushSchema = (maxFlushPumpFlowRate?: number) => object().shape({
  reference: string().required(i18n._('Reference is required')),
  backfillRecipeId: string().required(i18n._('Select the recipe the water will displace')),
  specification: object().shape({
    flushPumpMaxPressure: positiveNumber(i18n._('Flush pump max pressure')),
    flushPumpFlowRate: maxFlushPumpFlowRate
      ? positiveNumber(i18n._('Flush pump flow rate')).max(maxFlushPumpFlowRate, i18n._('Flush pump flow rate exceeds the project maximum'))
      : positiveNumber(i18n._('Flush pump flow rate')),
    pastePumpFlowRate: positiveNumber(i18n._('Paste pump flow rate')),
    airFlushEnabled: boolean().required(),
    airFlushMaxPressure: number()
      .typeError(i18n._('Must be a number'))
      .when('airFlushEnabled', {
        is: true,
        then: (schema) => schema
          .required(i18n._('Air purge max pressure is required'))
          .moreThan(0, i18n._('Air purge max pressure must be greater than zero')),
        otherwise: (schema) => schema.nullable().notRequired(),
      }),
    volumeMode: number().required(),
    volumeValue: number()
      .typeError(i18n._('Must be a number'))
      .when('volumeMode', {
        is: FlushVolumeMode.AirStartVolume,
        then: (schema) => schema.nullable().notRequired(),
        otherwise: (schema) => schema
          .required(i18n._('Flush volume is required'))
          .min(0, i18n._('Flush volume cannot be negative')),
      }),
  }),
});

export default generateFlushSchema;
